"use strict";

export default class FleetPortalAPI {
  constructor($http, $window, config) {
    this.$http = $http;
    this.$window = $window;
    this.config = config;
  }

  get(url, options) {
    if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

    options = angular.extend({}, options, this.getOptions());

    return this.$http.get(`${this.config.apiUrl}${url}`, options);
  }

  post(url, data, options) {
    if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

    options = angular.extend({}, options, this.getOptions());

    return this.$http.post(`${this.config.apiUrl}${url}`, data, options);
  }

  put(url, data, options) {
    if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

    options = angular.extend({}, options, this.getOptions());

    return this.$http.put(`${this.config.apiUrl}${url}`, data, options);
  }

  delete(url, options) {
    if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

    options = angular.extend({}, options, this.getOptions());

    return this.$http.delete(`${this.config.apiUrl}${url}`, options);
  }

  getOptions() {
    let userString = this.$window.sessionStorage["userAuthInfo"];
    let user = JSON.parse(userString);

    let options = {
      headers: {
        "ALK-Language": undefined,
        "Authorization": `Bearer ${user.authToken}`
      }
    };

    return options;
  }

  getPagingQuery(paging) {
    if (!paging) return [];

    let p = [];
    if (paging.pageNumber != null) p.push("pageNumber=" + paging.pageNumber);
    if (paging.limit != null) p.push("limit=" + paging.limit);
    if (paging.sortBy != null) p.push("sortBy=" + paging.sortBy);
    if (paging.sortAscending != null) p.push("sortAscending=" + paging.sortAscending);

    return p;
  }

  getArrayQuery(key, arr) {
    if (arr == null) return [];

    let p = [];

    if (this.isArray(arr)) {
      for (let i = 0; i < arr.length; i++) {
        p.push(key + "=" + arr[i]);
      }
    } else {
      // if passed in item is not an array, but instead a single item
      p.push(key + "=" + arr);
    }

    return p;
  }

  isArray(arg) {
    return Object.prototype.toString.call(arg) === "[object Array]";
  }

}

FleetPortalAPI.$inject = ["$http", "$window", "alk.fleetportal.config"];



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-fleetlink/fleetlink.api.js